import { render, staticRenderFns } from "./earlyWarning-G.vue?vue&type=template&id=2b952772&scoped=true&"
import script from "./earlyWarning-G.vue?vue&type=script&lang=js&"
export * from "./earlyWarning-G.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b952772",
  null
  
)

export default component.exports